import Modal from "components/Modal";
import SingleSelect from "components/SingleSelect";
import Text from "components/Text";
import { routeConstants } from "constants/routeConstants";
import { UserResponse } from "pages/Profile/EditProfile/PersonalDetails/types";
import {
    MileStone,
    MileStoneIcon,
} from "pages/Profile/HighLight/HighLight.styled";
import ImageSection from "pages/Profile/HighLight/ImageSection";
import { useHighLight } from "pages/Profile/HighLight/useHighLight";
import { Agency } from "pages/Profile/types";
import { FC } from "react";
import { BsInstagram, BsLink } from "react-icons/bs";
import { FaFacebookSquare, FaTwitterSquare } from "react-icons/fa";
import { HiBadgeCheck } from "react-icons/hi";
import { TbPencil } from "react-icons/tb";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "slice";
import theme from "theme";
import {
    BottomRow,
    ButtonSection,
    DetailSection,
    EditButton,
    FlexBetween,
    InstagramIcon,
    ListItem,
    ListSection,
    Name,
    ProfileHighlight,
    ShareIcon,
    ShareIcons,
    UserNameSection,
} from "./CompanyCard.styled";
import { SocialHandlesProps } from "./ContactCard";
import SocialHandle from "./SocialHandle";
const CompanyCard: FC<{
    socialHandles: SocialHandlesProps;
    data?: UserResponse;
}> = ({ socialHandles, data }) => {
    const { id: agency_id } = useParams();
    // const { data } = useGetUserQuery("1 ");
    const agencyDetails = data?.data?.attributes?.agency as Agency;
    const navigateTo = useNavigate();
    const { isModalOpen, availabilityStatus, toggleModal, handleChange } =
        useHighLight();

    const { user_type, experiences } = useAppSelector((state) => state.user);
    const handleEditProfile = () => {
        navigateTo(
            routeConstants.profile.editProfile.agency.root +
                routeConstants.profile.editProfile.agency.companyDetails
        );
    };
    return (
        <ProfileHighlight>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                <Modal.Header>
                    <Text variant="heading3">Share</Text>
                </Modal.Header>
                <Modal.Content>
                    <ShareIcons>
                        <ShareIcon>
                            <BsInstagram />
                            <Text variant="label">Instagram</Text>
                        </ShareIcon>
                        <ShareIcon>
                            <FaFacebookSquare />
                            <Text variant="label">Facebook</Text>
                        </ShareIcon>
                        <ShareIcon>
                            <FaTwitterSquare />
                            <Text variant="label">Twitter</Text>
                        </ShareIcon>
                        <ShareIcon>
                            <BsLink />
                            <Text variant="label">Copy Link</Text>
                        </ShareIcon>
                    </ShareIcons>
                </Modal.Content>
            </Modal>
            {agencyDetails && (
                <ImageSection agency_logo={agencyDetails.company_logo} />
            )}
            <DetailSection>
                {/* <InstagramIcon>
                    <BsInstagram color={theme.colors.grey.dark} />
                    <Text variant="label" fontWeight="500" color="#8A8A8A">
                        145k
                    </Text>
                </InstagramIcon> */}
                <InstagramIcon>
                    <SocialHandle socialHandles={socialHandles} />
                </InstagramIcon>
                <FlexBetween>
                    <UserNameSection>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                            }}
                        >
                            <Name variant="heading2">
                                {agencyDetails?.name}
                            </Name>
                            {/* <ProBadge src={ProBadgeImage} alt="Pro Badge Image" /> */}
                            <Text
                                variant="body2"
                                color={theme.colors.grey.dark}
                                style={{
                                    display: "flex", // Enable flexbox
                                    alignItems: "center", // Vertically align items
                                    justifyContent: "space-between", // Space items if needed
                                    gap: "10px", // Add spacing between items
                                }}
                            >
                                {agencyDetails?.is_verified && (
                                    <MileStone
                                        left={"0"}
                                        isVerifiedMileStone={false}
                                        isComplete={false}
                                    >
                                        <MileStoneIcon>
                                            <HiBadgeCheck />
                                        </MileStoneIcon>
                                    </MileStone>
                                )}
                            </Text>
                        </div>

                        {/* <ProBadge src={ProBadgeImage} alt="Pro Badge Image" /> */}
                        <Text variant="body2" color={theme.colors.grey.dark}>
                            <a
                                href={agencyDetails?.website}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {agencyDetails?.website}
                            </a>
                        </Text>
                        <Text variant="body2" color={theme.colors.grey.dark}>
                            {agencyDetails?.details}
                        </Text>
                    </UserNameSection>
                    <ButtonSection>
                        {!agency_id && (
                            <EditButton>
                                <TbPencil
                                    fontSize="18px"
                                    onClick={handleEditProfile}
                                />
                            </EditButton>
                        )}
                        {/* <ShareButton
                            type="button"
                            variant="filled"
                            onClick={() => {}}
                        >
                            <ShareButtonContent>
                                <BsShare color="fff" />
                                <Text variant="button1">Share</Text>
                            </ShareButtonContent>
                        </ShareButton> */}
                    </ButtonSection>
                </FlexBetween>
                <BottomRow>
                    <SingleSelect
                        label=""
                        value={availabilityStatus}
                        options={[
                            {
                                value: "Available",
                                label: "Available to work",
                                selected: true,
                            },
                            {
                                value: "Unavailable",
                                label: "unavailable to work",
                            },
                        ]}
                        onChange={handleChange}
                    />

                    {experiences && (
                        <ListSection>
                            <ListItem>
                                <Text
                                    variant="label"
                                    color={theme.colors.grey.primary}
                                    fontWeight="500"
                                >
                                    Type
                                </Text>
                                <Text variant="label" fontWeight="500">
                                    {user_type}
                                </Text>
                            </ListItem>
                            <ListItem>
                                <Text
                                    variant="label"
                                    color={theme.colors.grey.primary}
                                    fontWeight="500"
                                >
                                    Experience
                                </Text>
                                <Text variant="label" fontWeight="500">
                                    4 years
                                </Text>
                            </ListItem>
                        </ListSection>
                    )}
                </BottomRow>
            </DetailSection>
        </ProfileHighlight>
    );
    // return (
    //     <ProfileContentWrapper className="contact-card">
    //         <ImageSection />
    //         <div style={{ display: "flex", gap: "2rem" }}>
    //             <div
    //                 style={{
    //                     width: "20vw",
    //                 }}
    //             ></div>
    //             <div className="contact-details">
    //                 <h2 style={{ color: "black" }}>{agencyDetails?.name}</h2>
    //                 <br />
    //                 <div className="contacturl_div">
    //                     <div className="faded-text">
    //                         Url : {`\u00a0`} {`\u00a0`}{" "}
    //                     </div>
    //                     <div className="descriptive-text">
    //                         {agencyDetails?.website}
    //                     </div>
    //                 </div>
    //                 <div className="contacturl_div">
    //                     <div className="faded-text">About </div>
    //                     <div className="descriptive-text">
    //                         {agencyDetails?.details}
    //                     </div>
    //                 </div>
    //             </div>
    //             <EditIcon onClick={handleEditProfile} />
    //         </div>
    //     </ProfileContentWrapper>
    // );
};

export default CompanyCard;
